import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { DraftAccountDTO } from '../../../AccountOpening.meta';
import { EditableField } from '../../../components/EditableField/EditableField';
import { SpaceProps } from '../../../../../theme/styledProps';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { getIncomeOption, netWorthOpts } from '../NetWorthFields.meta';

interface Props extends SpaceProps {
  isReview?: boolean;
  draftAccount: DraftAccountDTO;
}

export const LiquidNetWorth: React.FC<Props> = ({ isReview, draftAccount, ...rest }) => {
  const formBag = useFormContext();

  const { liquidNetWorthUSDMin, liquidNetWorthUSDDefault } = draftAccount;

  const [isEditing, setIsEditing] = useState(!isReview);

  const [incomeOpt, setIncomeOpt] = useState(() =>
    getIncomeOption(liquidNetWorthUSDMin, liquidNetWorthUSDDefault, netWorthOpts),
  );

  if (!isEditing) {
    return <EditableField onEdit={() => setIsEditing(true)}>{incomeOpt.label}</EditableField>;
  }

  return (
    <Box {...rest}>
      <input
        defaultValue={incomeOpt.value.min}
        type="hidden"
        {...formBag.register('liquidNetWorthUSDMin', { valueAsNumber: true })}
      />
      <input
        defaultValue={incomeOpt.value.max}
        type="hidden"
        {...formBag.register('liquidNetWorthUSDMax', { valueAsNumber: true })}
      />

      <Select
        value={incomeOpt}
        label={isReview ? undefined : 'Estimated Liquid Net Worth'}
        onChange={opt => {
          if (opt) {
            formBag.setValue('liquidNetWorthUSDMin', opt.value.min);
            formBag.setValue('liquidNetWorthUSDMax', opt.value.max);

            setIncomeOpt(opt);
          }
        }}
        options={netWorthOpts}
        aria-label="Estimated Liquid Net Worth"
      />
    </Box>
  );
};
